var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPriceTaginline = function SvgPriceTaginline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.5 2.2c-.4 0-.8.2-1.1.5l-9.9 9.9c-.3.3-.4.9 0 1.3l7.6 7.7c.4.3.9.3 1.3 0l10.2-10.2c.1-.1.2-.3.2-.4V3.8c0-.9-.7-1.6-1.6-1.6h-6.7zm0-2.2c-1 0-2 .4-2.7 1.1L.9 11c-1.2 1.2-1.2 3.2 0 4.4l7.6 7.7c1.2 1.2 3.2 1.2 4.4 0l10.2-10.2c.5-.5.8-1.3.8-2V3.8c0-2.1-1.6-3.8-3.7-3.8h-6.7zm-2 6.2c.5 0 1 .4 1 1v.4c.9.1 1.7.5 2.2 1.3.3.4.2 1-.3 1.3-.4.3-1 .2-1.3-.3-.2-.3-.5-.4-.8-.4h-1.6c-.6 0-1 .5-1 1.1 0 .6.5 1 1 1h1.6c1.6 0 3 1.3 3 3 0 1.6-1.2 2.9-2.8 2.9v.4c0 .5-.4 1-1 1-.5 0-1-.4-1-1v-.4c-1-.1-1.8-.6-2.3-1.4-.3-.5-.1-1 .4-1.3.5-.3 1-.1 1.3.4.2.3.5.5.8.5h1.6c.6 0 1-.5 1-1 0-.6-.5-1-1-1h-1.6c-1.6 0-3-1.3-3-3 0-1.6 1.2-2.9 2.8-3v-.6c.1-.5.5-.9 1-.9zm8.7-.4c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2z",
    clipRule: "evenodd"
  })));
};

export default SvgPriceTaginline;